import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ModalDeleteItem from '../../Modal-Delete-Item';
import ClientStatus from './Client-Status';
import { Kanban } from 'libs/kanban';
import { TabPaneStyles } from '../Tab-Pane-Focuses/styles';

const TabPaneClientStatus = ({ setStatus, clientStatus, setClientStatus }) => {
  const { t: translate } = useTranslation();
  const { search } = window.location;
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const seo = new Kanban('seo', accountParam);
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const toggleModal = () => {
    const willClose = isOpenModalDelete;
    setIsOpenModalDelete(!isOpenModalDelete);

    if (willClose) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const deleteStatus = async () => {
    return seo.deleteTypeItem('client-status', selectedStatus.id);
  };

  return (
    <TabPaneStyles>
      <span>Status {translate('Client')}</span>
      <div className="d-flex flex-column gap-2">
        {(Array.isArray(clientStatus) ? clientStatus.filter(Boolean) : []).map((status) => (
          <ClientStatus
            key={status?.id}
            id={status?.id}
            name={status?.name}
            setItems={setClientStatus}
            index={clientStatus.filter(Boolean).findIndex((col) => col.id === status.id)}
            total={clientStatus.filter(Boolean).length}
            isNew={status.isNew}
            setSelectedItem={setSelectedStatus}
            setIsOpenModalDelete={setIsOpenModalDelete}
            setStatus={setStatus}
          />
        ))}
        <Button
          color="outline"
          style={{ width: '37.5rem' }}
          onClick={() => {
            if (!Array.isArray(clientStatus)) {
              setClientStatus([{ id: 'temp-1', name: '', isNew: true }]);
            } else {
              setClientStatus([
                ...clientStatus.filter(Boolean),
                { id: `temp-${clientStatus.filter(Boolean).length + 1}`, name: '', isNew: true },
              ]);
            }
          }}
        >
          <i className="bx bx-plus" />
          {translate('Add status')}
        </Button>
      </div>
      <ModalDeleteItem
        isOpen={isOpenModalDelete}
        toggle={toggleModal}
        item={selectedStatus}
        setItems={setClientStatus}
        setStatus={setStatus}
        onDelete={deleteStatus}
        headerText="Delete status"
        bodyText="Are you sure you want to delete the status {{item}}?"
      />
    </TabPaneStyles>
  );
};

TabPaneClientStatus.propTypes = {
  setStatus: PropTypes.func.isRequired,
  clientStatus: PropTypes.array.isRequired,
  setClientStatus: PropTypes.func.isRequired,
};

export default TabPaneClientStatus;
